// src/axiosInstance.js
import axios from "axios";
import Cookies from "js-cookie";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_DLS_DOMAIN,
  // baseURL: "https://localhost:7102",
  // baseURL: "http://dentallabor.live1.dev.radixweb.net/",
  // baseURL: "http://dental-labor-qa-backend.live1.dev.radixweb.net/",
  //baseURL: "https://api.rdxdls.de/",
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Add authorization token or any custom headers if needed
    // const token = localStorage.getItem("accessToken"); // Replace with your token retrieval logic
    const token = Cookies.get("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"]; // Let Axios handle it for FormData
    } else {
      config.headers["Content-Type"] = "application/json"; // Default for JSON requests
    }
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // You can handle global response transformation here
    return response.data; // Return only the data from the response
  },
  (error) => {
    // Handle response errors globally
    if (error.response) {
      // Server responded with a status code outside the 2xx range
      console.error("API Error:", error.response?.status, error.response?.data);
      if (error.response?.status === 401) {
        // Unauthorized: Redirect to login or refresh token logic
        //window.location.href = "/login";
        console.error("Network Error:", error.response.data);
      }
    } else if (error.request) {
      // No response received from the server
      console.error("Network Error:", error.message);
    } else {
      // Something went wrong in setting up the request
      console.error("Error:", error.message);
    }
    return Promise.reject(error);
  }
);

// Export the instance so you can reuse it throughout the app
export default axiosInstance;
